import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tab-wr" }
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = {
  key: 0,
  class: "income-tabs-wr"
}
const _hoisted_4 = { class: "default-form" }
const _hoisted_5 = { class: "buttons-section" }
const _hoisted_6 = { class: "input-wr borrow-calculator" }
const _hoisted_7 = ["onChange", "value"]
const _hoisted_8 = { class: "input-wr no-margin borrow-calculator" }
const _hoisted_9 = { class: "input dropdown-input" }
const _hoisted_10 = { class: "buttons-section" }
const _hoisted_11 = {
  key: 0,
  class: "buttons-section"
}
const _hoisted_12 = { class: "input-wr borrow-calculator" }
const _hoisted_13 = ["onChange", "value"]
const _hoisted_14 = { class: "input-wr no-margin borrow-calculator" }
const _hoisted_15 = { class: "input dropdown-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.props.form?.JointIncome === '1' ? true : false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["income-tab", { active: $setup.props.formCalculatorOptions?.isApplicant1Active }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateFormCalculatorOptions($setup.CalculatorOptionsFields.IS_APPLICANT_1_ACTIVE, true)))
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "icon-user" }, null, -1),
              _createTextVNode("Applicant 1", -1)
            ]))], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["income-tab", { active: !$setup.props.formCalculatorOptions?.isApplicant1Active }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateFormCalculatorOptions($setup.CalculatorOptionsFields.IS_APPLICANT_1_ACTIVE, false)))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "icon-user" }, null, -1),
              _createTextVNode("Applicant 2", -1)
            ]))], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tab-title" }, "Employment income before tax", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "tab-subtitle" }, "Includes bonuses and commissions", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              class: "input",
              onChange: (e) => $setup.updateFormInput(e, $setup.activeApplicant.netSalaryKey),
              type: "text",
              value: $setup.activeApplicant.netSalaryValue,
              placeholder: "Income"
            }, null, 40, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_9, _toDisplayString($setup.getPeriodicityKey($setup.activeApplicant.netSalaryFreValue)), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateForm($setup.activeApplicant.netSalaryFreKey, $setup.Periodicity.YEARLY)))
                  }, "yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateForm($setup.activeApplicant.netSalaryFreKey, $setup.Periodicity.HALF_YEARLY)))
                  }, "half yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateForm($setup.activeApplicant.netSalaryFreKey, $setup.Periodicity.MONTHLY)))
                  }, "monthly"),
                  _createElementVNode("li", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.updateForm($setup.activeApplicant.netSalaryFreKey, $setup.Periodicity.FORTNIGHTLY)))
                  }, "fortnightly")
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "tab-title" }, "Do you receive any additional income?", -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(["green-button-container borrow-calculator borderless", $setup.activeApplicant.hasAdditionalIncomeValue ? 'active' : 'un-active']),
            tabindex: "0",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateHasAdditonalIncome($setup.activeApplicant.hasAdditionalIncomeKey, $setup.activeApplicant.additionalIncomeKey, true)))
          }, "Yes", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["green-button-container borrow-calculator borderless", !$setup.activeApplicant.hasAdditionalIncomeValue ? 'active' : 'un-active']),
            tabindex: "0",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateHasAdditonalIncome($setup.activeApplicant.hasAdditionalIncomeKey, $setup.activeApplicant.additionalIncomeKey, false)))
          }, "No", 2)
        ]),
        ($setup.activeApplicant.hasAdditionalIncomeValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("input", {
                  class: "input",
                  onChange: (e) => $setup.updateAdditonalIncome(e, $setup.activeApplicant.additionalIncomeKey),
                  type: "text",
                  value: $setup.activeApplicant.additionalIncomeValue,
                  placeholder: "Additional income"
                }, null, 40, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode($setup["DropDown"], null, {
                  control: _withCtx(() => [
                    _createElementVNode("button", _hoisted_15, _toDisplayString($setup.getPeriodicityKey($setup.props.form?.NetSalaryFre3)), 1)
                  ]),
                  dropdown: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.NET_SALARY_FRE_3, $setup.Periodicity.YEARLY)))
                      }, "yearly")
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}